<template>
  <a-row :gutter="12">
    <a-col :span="16">
      <a-card style="margin-bottom: 10px;" :body-style="{paddingBottom: '20px'}">
        <a-form-model ref="form" layout="horizontal" :model="formData" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-row :gutter="10">
            <a-col :span="24">
              <a-form-model-item label="需求应用时间" prop="expectTime" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-date-picker v-model="formData.expectTime" :disabled-date="disabledDate" placeholder="请选期望上线时间" value-format="YYYY-MM-DD" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="10">
            <a-col :span="24">
              <a-form-model-item label="追溯信息" prop="remark" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-input v-model="formData.remark" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="10">
            <a-col :span="24">
              <a-form-model-item label="追溯附件" prop="files" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <UploadFile :key="key" :is-edit="true" :data-list.sync="formData.files" @startUpdate="fileUpdate(true)" @endUpdate="fileUpdate(false)" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="10">
            <a-col :span="24">
              <a-form-model-item label="相关图片" prop="images" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <UploadImg :key="key" :is-edit="true" :data-list.sync="formData.images" @startUpdate="imgUpdate(true)" @endUpdate="imgUpdate(false)" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </a-col>
    <a-col :span="8">
      <a-card style="margin-bottom: 10px;" :body-style="{paddingBottom: '20px'}">
        <a-form-model ref="form1" layout="vertical" :model="formData" :rules="rules">
          <a-form-model-item label="是否符合预期" prop="expectTime" :wrapper-col="{ span: 21 }">
            <a-radio-group v-model="formData.expectTime" prop="expectTime">
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="追溯小结" prop="expectTime" :wrapper-col="{ span: 21 }">
            <a-date-picker v-model="formData.expectTime" :disabled-date="disabledDate" placeholder="请选期望上线时间" value-format="YYYY-MM-DD" />
          </a-form-model-item>
          <a-form-model-item label="后续计划" prop="remark" :wrapper-col="{ span: 21 }">
            <a-input v-model="formData.remark" />
          </a-form-model-item>
        </a-form-model>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import UploadImg from '@/pages/business/requirement/components/UploadImg';
import UploadFile from '@/pages/business/requirement/components/UploadFile';
import moment from 'moment';
export default {
  components: { UploadImg, UploadFile },
  props: {
    dataSource: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      projectId: 0,
      formData: {
        images: [],
        files: []
      },
      key: 0,
      rules: {}
    };
  },
  created() {

  },
  destroyed() {
  },
  methods: {
    init() {
    },
    onReload() {
      this.$emit('onReload');
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day');
    },
    initData() {

    }
  }
};
</script>

<style lang="less" scoped></style>
